const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/blog/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import "../../../../components/blog/editor.css";
export const Route = createFileRoute("/dashboard/admin/blog/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});